import React from "react";
import { useTranslation } from "react-i18next";
import './ParentARMScoreInfo.scss';
import { useSelector } from "react-redux";

const ParentARMScoreInfo = ({ studentName, i18n }) => {
  
  const { t } = useTranslation(["teacher_parent_report"], {i18n});
  const selectedLocale = useSelector(state => state?.reports?.teacher?.selectedLocale || "EN-US")

  const tContext = {
    studentName,
    interpolation: { escapeValue: false },
  };

  return (
    <div className='parent-ARM-score-info'>
      {t("parent_arm_score_info", tContext)}
    </div>
  );
};

export default ParentARMScoreInfo;
